module.exports = __webpack_public_path__ + "img/NCBconsent.1d5d4725.svg";